/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { useRef, useState,useEffect, useCallback, useContext} from 'react';
import CardHeader from "../../../components/CardHeader"
import Table from './Components/Table'
import { useSearchParams } from 'react-router-dom'
import Search from './Components/Search'
import Filter from './Components/Filter'
import { useOnClickOutside } from '../../../CommonMethods/OutsideClick';
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import { dataService } from '../../../services/data.services';
import Debounce from '../../../CommonMethods/Debounce';
import Shimmer from '../../../components/Shimmer/itemShimmer'
import SearchEmptyScreen from '../../../components/SearchEmptyScreen';
import EmptyAddScreen from '../../../components/EmptyAddScreen'
import Toast from '../../../components/Toast';
import { DataStore } from 'aws-amplify';
import { formatAdjustedDate } from '../../../CommonMethods/formatDate';
import GlobalContext from '../../../components/Context/GloablContext'
import moment from 'moment';

const FeeCollection = () => { 
    const {reloadFY, setReloadFY} = useContext(GlobalContext);
    const [searchParams, setSearchParams] = useSearchParams()
    let dependencies = [searchParams];
    const [toastErrorMessage, setToastErrorMessage] = useState("")
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [finacialYear, setFinacialYear] = useState('')
    const [academicYears, setAcademicYears] = useState('')
    const [classes, setClasses] = useState([])
    const [sections, setSections] = useState([])
    const [feeCollectionList, setFeeCollectionList] = useState([])
    const [reportTotal, setReportTotal] = useState([])
    const [feeCollectionCount, setFeeCollectionCount] = useState(0)
    const [feeCollectionTotalCount, setFeeCollectionTotalCount] = useState(0)
    const [loading, setLoading] =useState(true)
    const [selectedDateRange, setSelectedDateRange] = useState(searchParams.get('dropname') !== null ? searchParams.get('dropname') : 'Financial Year')
    const [searchFieldDebounce, setsearchFieldDebounce] = useState(searchParams.get('search') === null ? '' : decodeURIComponent(searchParams.get('search')));
    const [selectedName, setSelectedName] = useState(searchParams?.get('main') !== null ? searchParams?.get('main'):'')  ;
    const [currentFinacialYear, setCurrentFinacialYear] = useState('')
    const [FilterData, setFilterData] = useState({date_range : [],"class_": [],"section_": [], "entry_type":['Receipt', 'RTE', 'Scholarship', 'Discount', 'Write-off']});
    const [filterCount, setFilterCount] = useState(0)
    const [FilterCheckbox, setFilterCheckBox] = useState({})
    const [selectedFilter, setSelectedFilter] = useState(Object.keys(FilterData !==undefined&& FilterData)[0]||'city');
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [classesLoading, setClassesLoading] = useState(true);
    const [sectionsLoading, setSectionsLoading] = useState(true);
    const [FYLoading, setFYLoading] = useState(true);
    const outSideClick = useRef();
    const [placeholderIndex, setPlaceholderIndex] = useState(0);
    const placeholderOptions = [
        'Student Name / ID',
        'Receipt #'
    ];

    /**
     * The `formatDate` function takes an input date string and returns it in the format "YYYY-MM-DD".
     * @returns The function `formatDate` returns a formatted date string in the format "YYYY-MM-DD".
     */
    const formatDate = (inputDateString) => {
        const inputDate = new Date(inputDateString);
        const year = inputDate.getFullYear();
        const month = String(inputDate.getMonth() + 1).padStart(2, '0');
        const day = String(inputDate.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    
    //Fliter Functions----
    /**
     * The function `updateFilterCheckBox` creates an object with non-null properties from searchParams,
     * filters out null or undefined values, updates the state with the filtered values, and counts the
     * number of filtered values.
     */
    const updateFilterCheckBox = () => {
        // Create an object with non-null properties from searchParams
        const filterState = {
            class_: searchParams.get('class_'),
            start_date: searchParams.get('start_date'),
            end_date: searchParams.get('end_date'),
            section_: searchParams.get('section_'),
            entry_type: searchParams.get('entry_type'), 
        };
        // Filter out null or undefined values
        const filteredFilterState = Object.fromEntries(
            Object.entries(filterState).filter(([_, value]) => value !== null && value !== undefined)
        );
        // Update the state with the filtered values
        setFilterCheckBox(filteredFilterState);
        let count = 0
        Object.keys(filteredFilterState).map((item) =>  {
            if(filteredFilterState[item] &&filteredFilterState[item]?.length !== 0 && item!=="end_date") {
                count += 1
            }
        })
        setFilterCount(count)
    };

    /* The below code is using the `useEffect` hook in React to set up an interval that changes the
    placeholder index cyclically every 2 seconds. The `setPlaceholderIndex` function is used to update
    the state of the placeholder index based on the previous index value and the length of the
    `placeholderOptions` array. The interval is cleared when the component unmounts to prevent memory
    leaks. */
    useEffect(() => {
        const interval = setInterval(() => {
            // Change placeholder index cyclically
            setPlaceholderIndex(prevIndex => (prevIndex + 1) % placeholderOptions.length);
        }, 2000);

        return () => clearInterval(interval);
    }, []);

    /**
     * The function `getCount` counts the number of non-empty values in the `FilterCheckbox` object and
     * updates the `filterCount` state variable accordingly.
     */
    const getCount = (type) => {
        let count = 0
        Object.keys(FilterCheckbox).map((item) =>  {
            if(FilterCheckbox[item] &&FilterCheckbox[item]?.length !== 0 && item!="end_date") {
                count += 1
            }
        })
        setFilterCount(type ? count : 0)
    }
    
    /**
     * The function `handleOpenFilter` updates the filter values based on the search parameters and toggles
     * the filter open state.
     */
    const handleOpenFilter = () => {
        let filter_val = {}
        Object.keys(FilterData).map((item) => {
            let params = Object.fromEntries(searchParams);
            Object.keys(params).map((subitem) => {
                if(item === subitem) {
                    if(item === "entry_type") {
                        filter_val[item] = params[item].split(',');
                    } else {
                        filter_val[item] = params[item].split(',')
                    }
                }
                if(subitem==='start_date' ||subitem==='end_date'){
                    filter_val[subitem]=params[subitem]
                }
            })
            setFilterCheckBox(filter_val)      
        })
        setIsFilterOpen((prevState)=> !prevState)
        setSelectedName(searchParams?.get('main') !== null ? searchParams?.get('main') : currentFinacialYear)
        setSelectedFilter('date_range')
        setSelectedDateRange(searchParams.get('dropname') !== null ? searchParams.get('dropname') : 'Financial Year')
    }
    /* The `useOnClickOutside` is a custom hook that is used to detect clicks outside of a specific
    element. In this case, it is used to detect clicks outside of the filter component. When a click is
    detected outside of the filter component, the callback function `() => { setIsFilterOpen(false) }`
    is executed, which sets the `isFilterOpen` state to `false`, closing the filter component. */
    useOnClickOutside(outSideClick, () => {
        setIsFilterOpen(false)
    })
    /**
     * The function `handleSelectObject` updates the state of `FilterCheckbox` based on the selected
     * object's id, dateString, and selectedFilter.
     */
    const handleSelectObject = (id,dateString,selectedFilter) => {
        if(id === 'start_date' || id === 'end_date') {
            setFilterCheckBox((prv)=>({
                ...prv,
                [id]: dateString
            }))
        }  else {
            setFilterCheckBox((prv)=>({
                ...prv,
                [selectedFilter]:[id]
            }))
        } 
    }
    /**
     * The function `handleApplyFilter` is used to apply filters to a search query and update the search
     * parameters accordingly.
     */
    const handleApplyFilter = (type) => {
        let params = Object.fromEntries(searchParams);
        if(type && Object.keys(FilterCheckbox).length !==0) {
            params.main = selectedName
            if (selectedName === 'Custom') {
                if((FilterCheckbox['start_date']!==null && FilterCheckbox['end_date']!==null)){
                    params.dropname = 'Custom';
                } else {
                    setSearchParams({...params})
                }
            } else if (selectedName.includes('FY')) {
                params.dropname = 'Financial Year';
            } else {
                params.dropname = 'Academic Year';
            }
            setSearchParams({ ...params})
            let flag = true;
            params["filter"] = true
            params.page_number = 1
            Object.keys(FilterCheckbox).map((item) => {
                let val = ""
                if((item === 'start_date' || item === 'end_date') && FilterCheckbox[item]!==null) {
                    let val = FilterCheckbox[item]
                    params[item] = searchParams.get(item) !== val ? formatDate(val) : val
                    setSearchParams({ ...params})
                    flag = false
                } else if(FilterCheckbox[item] && FilterCheckbox[item]?.length !== 0 ) {
                    // For entry_type, join selected types
                    if (item === "entry_type") {
                        params[item] = FilterCheckbox[item].join(",");
                    } else {
                        FilterCheckbox[item].map((key) => {
                            val += `${key},`
                        })
                        params[item] = val.slice(0, -1)
                    }
                    setSearchParams({ ...params})
                    flag = false
                } else {
                    delete params[item] 
                    setSearchParams({ ...params})  
                }
                if(flag) {
                    delete params.filter
                    setSearchParams({ ...params})  
                }
            })
        } else {
            const searchParam = searchParams.get('search');
            searchParam !== null ? setSearchParams({'search': searchParam}) : setSearchParams({});            
            setSelectedDateRange('Financial Year')
            setSelectedName(currentFinacialYear)
            if (reloadFY) {
                const selectedFY = JSON.parse(localStorage.getItem('FY_details'));
                setCurrentFinacialYear(selectedFY.name)
                if (selectedFY) {
                    setStartDate(selectedFY.start_date);
                    setEndDate(calculateEndDate(selectedFY.end_date));
                }
            }
            setFilterCheckBox([])
            setSelectedFilter('date_range')
        }
        getCount(type)
    }
    //----

    //Search Functions ----
    /**
     * The function `handleSearchParams` updates the search parameters by adding or modifying a key-value
     * pair, and then updates the state with the new search parameters.
     */
    const handleSearchParams = (key, value) => {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value);}
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }
    /* The `optimizedFn` is a memoized version of the `Debounce` function that is used to debounce the
    `handleSearchParams` function. Debouncing is a technique used to limit the number of times a
    function is called by delaying its execution until after a certain amount of time has passed since
    the last time it was invoked. */
    const optimizedFn = useCallback(
        Debounce((key, value) => handleSearchParams(key,value)),
        [searchParams]
    );
    //----

    const calculateEndDate = (fyEndDate) => {
        const fyEndDate1 = new Date(fyEndDate);
        const currentDate = moment().endOf('day');
        return currentDate <= fyEndDate1 ? currentDate.toISOString() : fyEndDate;
    }
    //API Calls----
    /**
     * The function `getFinancialYears` retrieves financial years data from an API, sets the financial
     * years state, sets the current financial year state, and updates the search parameters.
     */
    const getFinancialYears = async() => {
        try {
            const branch_id = await GetBranchId()
            let endpoint = `financial-years?branch_id=${branch_id}&role=fee-collection-report&filter=true&status=open,closed,ongoing&sort=start_date%2Bdesc`
            const response = await dataService.GetAPI(endpoint, true)
            const temp1 = response?.data?.data?.financial_years
            setFinacialYear(temp1)
            const selectedFY = JSON.parse(localStorage.getItem('FY_details'));
            setCurrentFinacialYear(selectedFY.name)
            setSelectedName(searchParams?.get('main') !== null ? searchParams?.get('main') : selectedFY.name)
            const ongoingFYData = temp1.find(item => item.name === selectedFY.name);
            // If there's ongoing data, set the start and end dates in the state
            if (ongoingFYData) {
                setStartDate(ongoingFYData.start_date);
                setEndDate(calculateEndDate(ongoingFYData.end_date));
            }
        }
        catch (error) {
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        }
        finally {
            setFYLoading(false)
        }
        // setSearchParams({})
    }

    /**
     * The function `getClassesAPI` retrieves class names from an API and updates the filter data state
     * with the class names.
     */
    const getClassesAPI = async () => {
        try{
            setLoading(true)
            const branch_id = await GetBranchId()
            let endpoint = `classes?branch_id=${branch_id}&filter=true&status=true&role=fee-collection-report`
            const response = await dataService.GetAPI(endpoint, true);
            const temp = (response.data?.data?.data);
            setClasses(temp)
            const allClassesNames = temp.map(item => item.name);
            setFilterData((prevState)=>{
                return {
                    ...prevState,
                    class_: allClassesNames,
                }
            })
        } catch (error) {
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        } finally {
            setClassesLoading(false)
        }

    }

    /**
     * The function `getSectionsAPI` retrieves section names from an API and updates the filter data state
     * with the section names.
     */
    const getSectionsAPI = async () => {
        try{        
            setLoading(true)
            const branch_id = await GetBranchId()
            let endpoint = `sections?branch_id=${branch_id}&role=fee-collection-report`
            const response = await dataService.GetAPI(endpoint, true);
            const temp = (response.data?.data?.data);
            setSections(temp)
            const allSectionsNames = temp.map(item => item.name);
            setFilterData((prevState)=>{
                return {
                    ...prevState,
                    section_: allSectionsNames,
                }
            })
        } catch (error) {
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        } finally {
            setSectionsLoading(false)
        }
    }

    /**
     * The function `getAcademicYears` retrieves ongoing and upcoming academic years from an API based on
     * the branch ID and sets the retrieved data to the state variable `AcademicYears`.
     */
    const getAcademicYears = async() => {
        const branch_id = await GetBranchId()
        let endpoint = `academic-years?branch_id=${branch_id}&filter=true&status=ongoing,upcoming,completed&role=fee-collection-report`;
        const response = await dataService.GetAPI(endpoint, true)
        const temp = response?.data?.data?.data
        setAcademicYears(temp)
    }

    const getFeeCollectionListAPICall = useCallback(async () => {
        if(searchParams?.get('search') === null){
            setsearchFieldDebounce('')
        }
        // Continue with the rest of the function after classes and sections are set
        let className = classes.find(item => item.name === searchParams?.get('class_'));
        let class_id = className?._id ? className?._id : '';
        let sectionName = sections.find(item => item.name === searchParams?.get('section_'));
        let section_id = sectionName?._id ? sectionName?._id : '';
        try { 
            setLoading(true)     
            const branch_id = await GetBranchId()
            let endpoint = `collect-fees/fee-report?branch_id=${branch_id}&page_number=${
                searchParams?.get('page_number')===null ? '1' : searchParams?.get('page_number')}${
                searchParams?.get('search') === null ? '': `&search=${encodeURIComponent(searchParams?.get('search'))}` }${`&filter=true${
                searchParams?.get('start_date') === null ?`&start_date=${startDate.substring(0, 10)}` : `&start_date=${searchParams?.get('start_date')}`}${
                searchParams?.get('end_date') === null ? `&end_date=${endDate.substring(0, 10)}` :`&end_date=${searchParams?.get('end_date')}`}`}${classes?.length > 0 && sections?.length > 0 ? `${
                searchParams?.get('class_') === null ? "" : `&class_id=${class_id}`}${
                searchParams?.get('section_') === null ? "" : `&section_id=${section_id}`}`: ''}${
                searchParams?.get('entry_type') ? `&entry_type=${searchParams.get('entry_type')}` : ''
            }${
                searchParams?.get('sort') === null 
                    ? '' 
                    : `&sort=${encodeURIComponent(searchParams.get('sort'))}`
            }`
            const response = await dataService.GetAPI(endpoint)
            const temp = response?.data?.data?.data
            const temp2 = response?.data?.data?.total_count
            const temp3 = response?.data?.data?.all_total_count
            const temp4 = response?.data?.data?.report_total
            setFeeCollectionList(temp)
            setFeeCollectionCount(temp2)
            setFeeCollectionTotalCount(temp3)    
            setReportTotal(temp4)
        } catch(error) {
            console.log(error)
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong");
        } finally{
            setLoading(false)
            updateFilterCheckBox();
        }
    }, [startDate, FYLoading, classes, sections, searchParams]);
    //----

    /* The below code is using the `useEffect` hook in a React component. It is calling three different API
    functions: `getClassesAPI()`, `getSectionsAPI()`, and `getFinancialYears()`. These functions are
    likely used to fetch data from an API. The `useEffect` hook is used to perform these API calls when
    the component mounts. The empty array `[]` as the second argument to `useEffect` ensures that the
    API calls are only made once, when the component initially mounts. */
    useEffect(()=>{
        getClassesAPI()
        getSectionsAPI()
        getFinancialYears()
        getAcademicYears()
    },[])
        
    /* The below code is a React useEffect hook that runs a function when the component mounts or when the
    `getFeeCollectionListAPICall` function changes. */
    useEffect(()=>{
        if (startDate != null && !FYLoading && !classesLoading && !sectionsLoading){
            getFeeCollectionListAPICall()
        }
    },[startDate, FYLoading, classesLoading, sectionsLoading, getFeeCollectionListAPICall, searchParams])

    useEffect(() => {
        if (reloadFY) {
            handleApplyFilter(false)
            setReloadFY(false);
        }
    }, [reloadFY]);

    return (
        <CardHeader noPadding>
            {/* top bar */}
            <div
                className="mainDataCntnrTop shadow-s13"
                style={{ position: "sticky", position: "-webkit-sticky"}}
            >
                <div className="flex justify-start">
                    <h5 class=" pageHeader adderror">
                        Fee Collection Report
                    </h5>
                </div> 
                <div className='flex items-center'>
                    {<Search
                        SearchValue={searchFieldDebounce}
                        handleOnClickSearch={setsearchFieldDebounce}
                        optimizedFn={optimizedFn}
                        customSearchPlaceHolder={placeholderOptions[placeholderIndex]}
                    />}
                    {<div class="relative">
                        <button onClick={() => {
                            handleOpenFilter()

                        }} type="button" id="filter_btn">
                            <img loading="lazy" src="/images/Filter_Icon.svg" alt="img" class="w-[15px] h-[15px]"/>
                            <span class="text-f2 font-normal text-[#106EB4] pl-2.5">Filter</span>
                            {filterCount !== 0 && <p class="p-2 text-[14px] leading-[7px] font-semibold text-[#FFFFFF] ml-2 bg-[#106EB4] rounded-[50%]">{filterCount}</p>}
                        </button>
                        {isFilterOpen && 
                        <Filter 
                            filterCount={filterCount}
                            selectedDateRange={selectedDateRange}
                            setSelectedDateRange={setSelectedDateRange}
                            selectedName={selectedName}
                            setSelectedName={setSelectedName}
                            searchParams={searchParams}
                            ref={outSideClick}
                            currentFinacialYear={currentFinacialYear}
                            handleSelectObject={handleSelectObject}
                            FilterCheckbox={FilterCheckbox}
                            setFilterCheckBox={setFilterCheckBox} 
                            FilterData={FilterData}
                            handleApplyFilter={handleApplyFilter}
                            setIsFilterOpen={setIsFilterOpen}
                            selectedFilter={selectedFilter}
                            setSelectedFilter={setSelectedFilter}  
                            radioButton={true}   
                            finacialYear={finacialYear}  
                            academicYears={academicYears}
                            setSearchParams={setSearchParams} 
                            setStartDate={setStartDate} 
                            setEndDate={setEndDate}   
                            calculateEndDate={calculateEndDate} 
                        />}
                    </div>}
                </div>
                {toastErrorMessage !== "" && (
                    <Toast
                        message={toastErrorMessage}
                        type="error"
                        setToastmessage={setToastErrorMessage}
                    />
                )}
            </div>
            <div class="mainDataCntnrListDiv scrollBlue_thick">
                { loading 
                    ? <div className='pt-[32px]'><Shimmer/></div>
                    :  
                    <>
                        <Table startDate={startDate} endDate={endDate} reportTotal={reportTotal} feeCollectionStudentList={feeCollectionList} setPageLoading={setLoading} searchParams={searchParams} setSearchParams={setSearchParams} feeCollectionStudentCount={feeCollectionCount} handleOnClickSort={handleSearchParams}
                            sortValue={searchParams.get('sort') || ''}/>
                    </>
                }
            </div>
        </CardHeader>
    )
}

export default FeeCollection;